import Headerimage from "./Headerimage";
import TextBlock1Blue from "./TextBlock1Blue";
import Novel from "./Novel";
import TextBlock2White from "./TextBlock2White";
import TextBlock3Parallax from "./TextBlock3Parallax";
import Video from "./Video";


const Parts = [
    Headerimage,
    TextBlock1Blue,
    Novel,
    TextBlock2White,
    TextBlock3Parallax,
    Video,
];

export {Parts};
